import React from "react";
import { Link } from "react-router-dom";
import CalendarIcon from "../assets/icons/Planner.png";
import DealIcon from "../assets/icons/Discount.png";
import SpinAndWinIcon from "../assets/icons/Community ticket.png";

export default function MobileMenu() {
  const path = window.location.href.split("?")[0].split("/").pop();

  const options = [
    {
      id: "events",
      icon: CalendarIcon,
      name: "Events",
      link: "/",
      activeLink: "",
    },
    {
      id: "deals",
      icon: DealIcon,
      name: "Deals",
      link: "/lifestyle",
      activeLink: "lifestyle",
    },
    {
      id: "spin-and-win",
      icon: SpinAndWinIcon,
      name: "Win tickets",
      link: "/spin-and-win",
      activeLink: "spin-and-win",
    },
  ]

  return (
    <div className="bottom-0 z-[100] fixed flex justify-center items-center bg-[#0B0415] py-[16px] border-[#25202E] border-t w-full">
      {options.map((option) => (
        <Link
          key={option.id}
          to={option.link}
          className={`p-[4px] min-w-[71px] flex flex-col justify-center items-center text-[12px] text-neutral-300 leading-[16px] font-semibold gap-1 ${
            path === option.activeLink && "!text-[#AD7AEF]"
          }`}
        >
          <img
            src={option.icon}
            alt={option.name}
            className="w-[22px] h-[22px]"
            style={{
              filter:
                path === option.activeLink
                  ? "brightness(0) saturate(100%) invert(67%) sepia(37%) saturate(7096%) hue-rotate(226deg) brightness(102%) contrast(87%)"
                  : "none",
            }}
          />
          {option.name}
        </Link>
      ))}
    </div>
  );
}
